
  // WB: helper for Bulk + Wholesale Club conflicts
  (function () {
    // --- small helpers ---

    // Normalize text for comparison
    function normalize(str) {
      return String(str || '').trim().toLowerCase();
    }

    // Bulk values from metafield
    var bulkNamesRaw = window.WB_BULK_NAMES || [];
    var bulkNamesNormalized = bulkNamesRaw
      .map(normalize)
      .filter(function (v) { return v.length > 0; });

    function findBulkValueInOptions(options) {
      if (!options || !options.length || !bulkNamesNormalized.length) return null;
      for (var i = 0; i < options.length; i++) {
        var value = options[i];
        if (!value) continue;
        var norm = normalize(value);
        for (var j = 0; j < bulkNamesNormalized.length; j++) {
          if (norm === bulkNamesNormalized[j]) {
            // return original value like "400 lb"
            return value;
          }
        }
      }
      return null;
    }

    function findBulkValueInLineItem(item) {
      // cart.js: options_with_values: [{name: 'Size', value: '400 lb'}, ...]
      var opts = item && item.options_with_values;
      if (!opts || !opts.length || !bulkNamesNormalized.length) return null;

      for (var i = 0; i < opts.length; i++) {
        var v = opts[i].value;
        if (!v) continue;
        var norm = normalize(v);
        for (var j = 0; j < bulkNamesNormalized.length; j++) {
          if (norm === bulkNamesNormalized[j]) return v;
        }
      }
      return null;
    }

    function cartHasBulk(cart) {
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        var val = findBulkValueInLineItem(items[i]);
        if (val) return val; // return first matching value
      }
      return null;
    }

    function fetchCartJson() {
      // cart_url есть в Theme.routes, как в других скриптах темы
      var base = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
      return fetch(base + '.js', { credentials: 'same-origin' }).then(function (r) {
        return r.json();
      });
    }

    // Check if any item in cart has tag wholesale_club_product
    // cart.js не отдает теги, поэтому дополнительно дергаем /products/<handle>.js
    function cartHasWholesaleMembership(cart) {
      var items = (cart && cart.items) || [];
      var index = 0;

      function next() {
        if (index >= items.length) return Promise.resolve(false);
        var item = items[index++];
        var handle = item.handle;

        if (!handle && item.url) {
          var parts = item.url.split('/products/');
          if (parts[1]) {
            handle = parts[1].split(/[?#]/)[0];
          }
        }

        if (!handle) {
          return next();
        }

        return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (p) {
            var tags = p && p.tags ? p.tags : [];
            if (tags.indexOf('wholesale_club_product') !== -1) {
              return true;
            }
            return next();
          })
          .catch(function () {
            // if error – skip this product and continue
            return next();
          });
      }

      return next();
    }

    // --- modal helpers ---

    var modal = document.getElementById('wb-bulk-wholesale-modal');
    var messageEl = modal ? modal.querySelector('#wb-bulk-modal-message') : null;

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('wb-bulk-modal--active');
      modal.setAttribute('aria-hidden', 'true');
    }

    function showModal(message) {
      if (!modal || !messageEl) return;
      messageEl.textContent = message;
      modal.classList.add('wb-bulk-modal--active');
      modal.setAttribute('aria-hidden', 'false');
    }

    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target && e.target.hasAttribute('data-wb-bulk-close')) {
          e.preventDefault();
          closeModal();
        }
      });
    }

    // --- main guard object ---

    window.WB_BulkWholesaleGuard = {
      /**
       * Main entry point
       * @param {Object} payload
       * @param {Array} payload.formData - serialized form (serializeArray)
       * @param {Object} payload.product - product JSON (with variants, tags, etc.)
       * @returns {Promise<boolean>} - true если НУЖНО БЛОКИРОВАТЬ добавление
       */
            checkBeforeAdd: function (payload) {
        // If no bulk config – nothing to do
        if (!bulkNamesNormalized.length) {
          return Promise.resolve(false);
        }

        var formData = (payload && payload.formData) || [];
        var product = (payload && payload.product) || {};
        var variants = product.variants || [];

        // Determine if this is a Wholesale Club membership product by tag
        var productTags = Array.isArray(product.tags) ? product.tags : [];
        var isMembershipProduct = productTags.indexOf('wholesale_club_product') !== -1;

        // Find variant id from formData
        var variantId = null;
        for (var i = 0; i < formData.length; i++) {
          if (formData[i].name === 'id') {
            variantId = parseInt(formData[i].value, 10);
            break;
          }
        }

        if (!variantId) {
          // No variant id – cannot safely determine bulk options
          // For membership-only payloads we still can check cart, so don't early-return here.
          if (!isMembershipProduct) {
            return Promise.resolve(false);
          }
        }

        // Find variant object if available
        var variant = null;
        if (variants && variants.length && variantId) {
          for (var j = 0; j < variants.length; j++) {
            if (parseInt(variants[j].id, 10) === variantId) {
              variant = variants[j];
              break;
            }
          }
        }

        // Try to find bulk value for this variant (only if we actually have a variant)
        var bulkValueForVariant = null;
        if (variant && variant.options) {
          bulkValueForVariant = findBulkValueInOptions(variant.options || []);
        }

        // If it's neither membership nor bulk-variant → nothing to check
        if (!isMembershipProduct && !bulkValueForVariant) {
          return Promise.resolve(false);
        }

        // From here we always need to inspect the cart
        return fetchCartJson()
          .then(function (cart) {
            // CASE 1: adding a bulk variant → check for membership in cart
            if (bulkValueForVariant && !isMembershipProduct) {
              return cartHasWholesaleMembership(cart).then(function (hasMembership) {
                if (hasMembership) {
                  var msg1 =
                    'You cannot add a ' + bulkValueForVariant +
                    ' size because there\'s a Wholesale Club subscription in your cart. ' +
                    'Our membership discounts don\'t apply for ' + bulkValueForVariant +
                    ' products, so you can only check out with either the subscription OR the ' +
                    bulkValueForVariant + ' item.';
                  showModal(msg1);
                  return true; // block
                }
                return false; // allow
              });
            }

            // CASE 2: adding a membership product → check for bulk item in cart
            if (isMembershipProduct) {
              var bulkInCart = cartHasBulk(cart);
              if (bulkInCart) {
                var msg2 =
                  'You cannot add a Wholesale Club membership because there\'s a ' +
                  bulkInCart + ' item in your cart. ' +
                  'Our membership discounts don\'t apply for ' + bulkInCart +
                  ' products, so you can only check out with either the subscription OR the ' +
                  bulkInCart + ' item.';
                showModal(msg2);
                return true; // block
              }
            }

            // Default: no conflict detected
            return false;
          })
          .catch(function () {
            // If anything fails, don't block the add-to-cart
            return false;
          });
      }

    };
  })();

